import React from 'react';
import Navbar from './Navbar';
import HeroContent from './HeroContent';
import Sphere from './Sphere';
import Partners from './Partners';
import Services from './Services';
import ContactSection from './ContactSection';
import Footer from './Footer';

function App() {
  return (
    <div className="min-h-screen bg-slate-50 mesh-gradient overflow-x-hidden selection:bg-blue-100 selection:text-blue-900">
      <Navbar />

      <main className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-16 py-24 md:py-32">
        <section className="flex-1 w-full">
          <HeroContent />
        </section>

        <section className="flex flex-1 w-full justify-center mt-8 md:mt-0">
          <div className="relative aspect-square w-full max-w-[300px] sm:max-w-[380px] md:max-w-[460px] lg:max-w-[520px] xl:max-w-[560px] mx-auto">
            <Sphere />
          </div>
        </section>
      </main>

      <Partners />
      <Services />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
